import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import * as Icons from "heroicons-react";
import SideBar from "../Common/SideBar/SideBar";
import Header from "../Common/Header/Header";
import {
  useAccountQuery,
  useUpdateAccountMutation,
} from "../../services/accountApi";
import { notify } from "../Utility/Notify";
import LoadingModal from "../Common/Modal/LoadingModal";

const UpdateAccount = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const handleLoaderClose = () => setLoader(false);

  const { data: account, isSuccess } = useAccountQuery(id, { skip: !id });
  const [updateAccount] = useUpdateAccountMutation();
  const { register, handleSubmit, reset } = useForm();

  useEffect(() => {
    if (account) {
      reset({
        amount: account?.amount || "",
        paidTo: account?.paidTo || "",
        paymentMethodType: account?.paymentMethodType || "Cash",
        paymentType: account?.paymentType || "Advance",
        type: account?.type || "Debit",
        note: account?.note || "",
      });
    }
  }, [account, isSuccess, reset]);

  const handleUpdate = async (formData) => {
    setLoader(true);
    try {
      const payload = {
        _id: id,
        ...formData,
      };
      await updateAccount(payload).unwrap();
      notify("Account Updated Successfully", "success");
      navigate("/accounts");
    } catch (err) {
      console.error(err);
      notify("Failed to update account", "error");
    } finally {
      setLoader(false);
    }
  };

  return (
    <div>
      <LoadingModal
        title={"Please Wait"}
        onShow={loader}
        handleClose={handleLoaderClose}
      />
      <div className="container-fluid ">
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title="Update Transaction"></Header>
            <div className="row mt-3">
              <div className="col-md-6 offset-md-3">
                <Form onSubmit={handleSubmit(handleUpdate)}>
                  <Form.Group className="mb-3">
                    <Form.Label>Account No</Form.Label>
                    <Form.Control
                      type="text"
                      value={account?.acId || ""}
                      disabled
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Amount</Form.Label>
                    <Form.Control
                      type="number"
                      step="any"
                      placeholder="Enter amount"
                      {...register("amount", { required: true })}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Receiver / Paid To</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter receiver name"
                      {...register("paidTo")}
                    />
                  </Form.Group>

                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Payment Method</Form.Label>
                        <Form.Select {...register("paymentMethodType")}>
                          <option value="Cash">Cash</option>
                          <option value="Card">Card</option>
                          <option value="Cheque">Cheque</option>
                          <option value="MFS">MFS</option>
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Payment Type</Form.Label>
                        <Form.Select {...register("paymentType")}>
                          <option value="Advance">Advance</option>
                          <option value="Payment">Payment</option>
                        </Form.Select>
                      </Form.Group>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Type</Form.Label>
                        <Form.Select {...register("type")}>
                          <option value="Debit">Debit</option>
                          <option value="Credit">Credit</option>
                        </Form.Select>
                      </Form.Group>
                    </div>
                  </div>

                  <Form.Group className="mb-3">
                    <Form.Label>Note</Form.Label>
                    <textarea
                      className="form-control"
                      rows={3}
                      placeholder="Enter note..."
                      {...register("note")}
                    />
                  </Form.Group>

                  <div className="d-flex gap-2">
                    <Link to="/accounts" className="btn btn-outline-dark">
                      <Icons.X size={18} /> Cancel
                    </Link>
                    <Button variant="dark" type="submit">
                      <Icons.PlusOutline size={18} /> Update Transaction
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateAccount;